// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__L48Nr","menuLink":"menu_menuLink__bV0gx","active":"menu_active__wzdzQ"};